import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { DefaultFiltersState } from '@/stores'
import { QrC2BType } from '@/types.ts'

import { SetFilterValue } from '../shared.ts'

export interface C2BTableState extends DefaultFiltersState {
  qrcType?: QrC2BType
}

const initialState: C2BTableState = {
  qrcType: undefined,
  page: 0,
  showCount: 10,
}

const c2bSlice = createSlice({
  name: 'c2b',
  initialState,
  selectors: {
    filters: (state) => ({ page: state.page, showCount: state.showCount, sort: state.sort }),
    resettableStateFilters: (state, filters: (keyof C2BTableState)[]) => filters.map((e) => state[e]),
  },
  reducers: {
    setFilter: (state, action: PayloadAction<SetFilterValue<C2BTableState>>) => {
      return {
        ...state,
        page: action.payload.filterKey !== 'page' ? 0 : state.page,
        [action.payload.filterKey]: action.payload.filterValue,
      }
    },
    resetFilters: (state, action: PayloadAction<(keyof C2BTableState)[]>) => {
      const patch = Object.fromEntries(action.payload.map((key) => [key, initialState[key]]))
      return { ...state, ...patch }
    },
  },
})

export const { reducer: c2bReducer, selectors: c2bSelectors, actions: c2bActions } = c2bSlice
